module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/gl-ret-975.98fdee24f4c8d241.jpg"+" 975w",
        images: [{path: "https://static.sniffspot.com/packs/img/gl-ret-975.98fdee24f4c8d241.jpg",width: 975,height: 648}],
        src: "https://static.sniffspot.com/packs/img/gl-ret-975.98fdee24f4c8d241.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/gl-ret-975.98fdee24f4c8d241.jpg"},
        
        width: 975,
        height: 648
      }